export default __webpack_public_path__ + "static/media/alcohol.ded1dd11.svg";